export const LOAD_CONTRACT_LIST_STARTED = "LOAD_CONTRACT_LIST_STARTED";
export const LOAD_CONTRACT_LIST_SUCCEEDED = "LOAD_CONTRACT_LIST_SUCCEEDED";
export const LOAD_CONTRACT_LIST_FAILED = "LOAD_CONTRACT_LIST_FAILED";

export const LOAD_CONTRACT_INFORMATION_STARTED = "LOAD_CONTRACT_INFORMATION_STARTED";
export const LOAD_CONTRACT_INFORMATION_SUCCESS = "LOAD_CONTRACT_INFORMATION_SUCCESS";

export const SAVE_LEASING_CONTRACT_STARTED = "SAVE_LEASING_CONTRACT_STARTED";
export const SAVE_LEASING_CONTRACT_SUCCEEDED = "SAVE_LEASING_CONTRACT_SUCCEEDED";

export const EMPTY_CONTRACTS_FOR_RESTRUCTURING = "EMPTY_CONTRACTS_FOR_RESTRUCTURING";

export const SAVE_CONTRACT_LIST_FILTERS = "SAVE_CONTRACT_LIST_FILTERS";
